import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import './SaleBanner.css';

const SaleBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide the banner on specific plugin/setup flows to keep the UI clean
  if (location.pathname.startsWith('/setup') || location.pathname.startsWith('/plugin')) {
    return null;
  }

  return (
    <motion.div
      className="sale-banner-container"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      onClick={() => navigate('/products')}
    >
      <div className="sale-banner-content">
        <span className="sale-banner-badge">LIMITED TIME</span>
        <span className="sale-banner-text">40% OFF SITE-WIDE SALE</span>
        <span className="sale-banner-pill">Shop Now</span>
      </div>
    </motion.div>
  );
};

export default SaleBanner;
